export const capitalizeFirstLetter = (str: string) => {
  if (str === "lab_grown_diamond") return "LabGrownDiamond";
  if (!str) return "";
  return str.charAt(0).toUpperCase() + str.slice(1);
};
